/** The 7 steps of the evaluation wizard, in display order; the id is the `:step` route slug and
 *  the label key is literal so the i18n audit sees it. */
export const EVALUATION_STEPS = [
    { id: "contexte", labelKey: "reception.evaluation.steps.context" },
    { id: "composition", labelKey: "reception.evaluation.steps.composition" },
    { id: "socio-economique", labelKey: "reception.evaluation.steps.socioEconomic" },
    { id: "budget", labelKey: "reception.evaluation.steps.budget" },
    { id: "problematiques", labelKey: "reception.evaluation.steps.issues" },
    { id: "compte-rendu", labelKey: "reception.evaluation.steps.report" },
    { id: "cloture", labelKey: "reception.evaluation.steps.close" },
];
export const DEFAULT_EVALUATION_STEP = "contexte";
export function isEvaluationStepId(value) {
    return EVALUATION_STEPS.some((step) => step.id === value);
}
/** The step a `:step` route param shows: an unknown, empty or array one falls back to the default. */
export function toEvaluationStep(param) {
    return isEvaluationStepId(param) ? param : DEFAULT_EVALUATION_STEP;
}
